











































































import Vue from 'vue'
import ModalOverlay from '@/common/components/ModalOverlay.vue'
import { FullColorCategory } from '@/stockLibrary/queries/types'


export default Vue.extend({
  components: { ModalOverlay },
  props: {
    categories: {
      type: Array as () => FullColorCategory[],
      required: true
    },
    selectedCategoryId: {
      type: String,
      required: true
    }
  },
  data(): {
    compSelectedCategoryId: string | undefined
  } {
    return {
      compSelectedCategoryId: this.selectedCategoryId
    }
  },
  computed: {
    isMobile(): boolean {
      return window.innerWidth < 768
    }
  },
  methods: {
    selectCategory(id: string): void {
      this.compSelectedCategoryId = id
    },
    isSelectedCategory(id: string): boolean {
      return this.compSelectedCategoryId === id
    },
    confirmSelect(): void {
      this.$emit('changeCategory', this.compSelectedCategoryId)
    },
    closeModal(): void {
      this.$emit('close')
    }
  }
})
